const CommonEnum = {
  Components: {
    SeasonalitySwitch: {
      BorderRadius: 6
    }
  }
}

export default CommonEnum
